<template>
  <div class="d-flex flex-column">
    <v-date-picker
      :landscape="true"
      elevation="0"
      outlined
      v-model="value"
    ></v-date-picker>
    <v-btn
      :disabled="!value"
      @click="value = undefined"
      class="mt-2"
      color="primary"
      outlined
      >Clear completion date</v-btn
    >
  </div>
</template>

<script>
import formElementMixin from "./formElementMixin";

export default {
  mixins: [formElementMixin],
};
</script>
